function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.33567 3.33078C8.10817 3.55828 8.10817 3.92578 8.33567 4.15328L10.599 6.41661H1.74984C1.429 6.41661 1.1665 6.67911 1.1665 6.99995C1.1665 7.32078 1.429 7.58328 1.74984 7.58328H10.6048L8.3415 9.84661C8.114 10.0741 8.114 10.4416 8.3415 10.6691C8.569 10.8966 8.9365 10.8966 9.164 10.6691L12.4248 7.40828C12.6523 7.18078 12.6523 6.81328 12.4248 6.58578L9.15817 3.33078C8.9365 3.10328 8.56317 3.10328 8.33567 3.33078Z",
  fill: "currentColor"
});

var SvgIconForward = function SvgIconForward(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconForward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-forward.a1170411.svg";
export { ForwardRef as ReactComponent };